import styled from "styled-components";
import {
  PageContentHeaderActionsWrapper,
  PageContentWrapper,
} from "../../../../../styles/page";

export const MainWrapper = styled(PageContentWrapper)`
  padding: 4px 20px 38px;
  font-family: Pretendard;
  border-radius: 20px;
  background: #f0f3f8;
  height: auto;
`;

export const MainHeaderWrapper = styled(PageContentHeaderActionsWrapper)`
  display: flex;
  flex-direction: column;
  gap: 0px;
  font-size: 16px;

  > div {
    display: flex;
    justify-content: space-between;
    gap: 40px;
  }

  span {
    font-weight: 600;
  }

  .countTitle {
    font-weight: 500;
  }
`;

export const PageContentHeaderButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  height: 30px;
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 700;
  line-height: 17.9px;
  text-align: center;
  padding: 10px 62px;
`;

export const PushContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  padding: 0 50px;
  gap: 50px;
`;

export const PushContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  > .pushTitleWrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;

    > div {
      font-size: 22px;
      font-weight: 600;
    }

    > input[type="text"] {
      width: 611px;
      height: 36px;
      padding: 5px 8px 5px 8px;
      border-radius: 2.7px;
      border: 0.67px solid #b7b7b7;
      font-size: 15px;
    }

    > textarea {
      width: 611px;
      height: 72px;
      padding: 5px 8px 5px 8px;
      border-radius: 2.7px;
      border: 0.67px solid #b7b7b7;
      resize: none;
      overflow: auto;
      font-size: 15px;
      line-height: 1.5;
    }

    > .pushTitle {
      width: 611px;
      height: 36px;
      padding: 5px 8px 5px 8px;
      border-radius: 2.7px;
      border: 0.67px solid #b7b7b7;
      background: #f0f0f0;
      font-size: 15px;
      color: #808080;
    }

    > .pushText {
      width: 611px;
      height: 72px;
      padding: 5px 8px 5px 8px;
      border-radius: 2.7px;
      border: 0.67px solid #b7b7b7;
      background: #f0f0f0;
      resize: none;
      overflow: auto;
      font-size: 15px;
      line-height: 1.5;
      color: #808080;
    }

    span {
      font-size: 20px;
      font-weight: 600;
      color: #808080;
      margin-right: 15px;
    }

    input[type="radio"] {
      appearance: none;
      width: 24px;
      height: 24px;
      border: 2px solid #b7b7b7;
      border-radius: 50%;
      background-color: #fff;
      vertical-align: bottom;
    }

    input[type="radio"]:checked {
      background-color: #808080;
      border: 4px solid white;
      box-shadow: 0 0 0 1.6px #b7b7b7;
    }
  }
`;

export const PushPreview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > .phone {
    display: flex;
    flex-direction: column;
    color: white;

    > span {
      position: relative;
      top: 100px;
      left: 60px;
      font-size: 15px;
      font-weight: 500;
      color: #121212;
    }

    > img {
      width: 541px;
    }
  }

  > .iphone {
    .pushBox {
      display: flex;
      gap: 20px;
      position: relative;
      width: 581px;
      height: 121px;
      border-radius: 20px;
      background: #454545;
      padding: 18px 25px;
      box-sizing: border-box;
      align-items: center;
      bottom: 105px;
      right: 20px;

      > .pushIcon {
        background: white;
        width: 84px;
        height: 84px;
        border-radius: 12px;
        padding: 5px;
        box-sizing: border-box;

        > img {
          width: 74px;
          height: 74px;
        }
      }

      > .pushBoxContent {
        display: flex;
        flex-direction: column;
        font-family: Inter;
        font-size: 20px;
        font-weight: 600;
        text-align: left;
        width: 425px;
        height: 51px;

        > span {
          font-family: Inter;
          font-size: 20px;
          font-weight: 400;
          overflow: hidden;
        }
      }
    }
  }

  > .android {
    margin-top: -80px;

    .pushBox {
      position: relative;
      width: 581px;
      height: 128px;
      border-radius: 20px;
      background: #454545;
      padding: 18px 25px;
      box-sizing: border-box;
      bottom: 105px;
      right: 20px;

      > .pushApp {
        display: flex;
        align-items: center;
        gap: 15px;

        > .pushIcon {
          background: white;
          width: 42px;
          height: 42px;
          border-radius: 8px;
          padding: 2.5px;
          box-sizing: border-box;

          > img {
            width: 37px;
            height: 37px;
          }
        }

        > span {
          font-family: Inter;
          font-size: 15px;
          font-weight: 600;
        }
      }

      > .pushBoxContent {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        font-family: Inter;
        font-size: 15px;
        font-weight: 600;

        > span {
          font-size: 15px;
          font-weight: 300;
          overflow: hidden;
        }
      }
    }
  }

  > .previewGuide {
    width: 476px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 50px;
    margin-top: -40px;

    text-align: center;
    > span {
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-weight: 600;
      line-height: 1.2;
      color: #808080;
    }

    > .previewGuideTitle {
      font-size: 20px;
      font-weight: 700;
      color: #121212;
    }
  }
`;
